// src/constants/config.js
// Configuration globale de l'application - NE PAS MODIFIER

export const APP_CONFIG = {
  APP_NAME: 'Fynho',
  APP_VERSION: '1.0.0',

  // ⚠️ Remplace par ton vrai domaine une fois le backend en ligne sur Hostinger
  // Exemple : 'https://fynho.com/api' ou 'https://api.fynho.com'
  API_BASE_URL: 'https://fynho.com/api',

  DEFAULT_LAT: 4.0511, // Douala
  DEFAULT_LNG: 9.7679,
  DEFAULT_MAP_ZOOM: 12,

  SUPPORT_WHATSAPP: '+237640460565',
  SUPPORT_EMAIL: 'yvankarel3@gmail.com',
};

export default APP_CONFIG;